export default __webpack_public_path__ + "media/images/borders/orange-medium-border-34ee47f9763913fe22e224d814c2f0e6.svg";